import React from 'react'
import ReactApexChart from 'react-apexcharts';

export const ApexChart = ({ data }) => {
const options = {
  chart: { id: 'user-stats', toolbar: { show: false } },
  plotOptions: {
    bar: {
      borderRadius: 6,
      columnWidth: '40%',
    },
  },
  xaxis: {
    categories: ['Total Users', 'New Users', 'Old Users'],
    labels: { style: { fontSize: '14px' } },
  },
  dataLabels: {
    enabled: true,
    style: {
      colors: ['#000']
    }
  },
  colors: ['#3b82f6'],
};


  const series = [
    {
      name: 'Users',
      data: [
        data?.total_users || 0,
        parseInt(data?.new_users) || 0,
        parseInt(data?.old_users) || 0
      ]
    }
  ];

  return (
    <ReactApexChart options={options} series={series} type="bar" height={300} />
  );
};
